module.exports = __webpack_public_path__ + "static/media/s2.adb53805.jpg";